import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import TextBoxSearchIcon from "./text-box-search.svg";

export default class ShowBlocksUI extends Plugin {
  init() {
    const editor = this.editor;

    editor.set("showBlocks", false);

    editor.ui.componentFactory.add("showBlocks", () => {
      const command = editor.commands.get("showBlocks");
      const showBlocksButtonView = new ButtonView();

      showBlocksButtonView.set({
        icon: TextBoxSearchIcon,
        isToggleable: true,
        tooltip: true,
        withText: false,
      });

      showBlocksButtonView.bind("isOn").to(command, "value");
      showBlocksButtonView.bind("isEnabled").to(command, "isEnabled");
      showBlocksButtonView
        .bind("label")
        .to(command, "value", (value) =>
          value ? "Hide Blocks" : "Show Blocks",
        );
      showBlocksButtonView.on("execute", (e) => {
        command.execute(!command.value);
      });
      return showBlocksButtonView;
    });
  }
}
